function GetUrlParam3(name) {// 获取url里的参数，name为想要获取参数的名称
    var search=window.location.search.split('?');
    if(search.length <= 1 ){
        return null
    }else {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        var r = ('?'+search[1]).substr(1).match(reg);  //匹配目标参数
        if (r != null) return decodeURI(r[2]); return null; //返回参数值
    }
}
export  {GetUrlParam3}